<template>
  <div>
    <el-dialog
      title="提示"
      :visible.sync="dialogVisibles"
      width="25%"
      :before-close="handleClose"
    >
      <div class="bodys">
        <div class="body_div">
          <img src="@/assets/home/login.png" alt="" width="100%" />
        </div>
        <div class="body_from">
          <div style="margin:auto;padding-left:30px" class="lip">
            <div class="div1" @click="links">
              <div class="divimg"><img src="@/assets/home/aic.jpg" alt="" /></div>
              <div class="divp">海外物流</div>
            </div>
            <div class="div1"  @click="links1">
              <div class="divimg">
                <img src="@/assets/del/logo.png" alt="" />
              </div>
              <div class="divp">DBS</div>
            </div>

            <!-- <li><a href="http://221.226.72.130:6060"></a></li> -->
          </div>
          <div style="margin-top:40px" class="btn">
            <el-button
              style="width:90%;"
              type="primary"
              round
              @click="handleClose"
              >确认</el-button
            >
          </div>
        </div>

        <!-- <el-button @click="dialogVisible = false">取 消</el-button>
    <el-button type="primary" @click="dialogVisible = false">确 定</el-button> -->
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: {
    dialogVisibles: {
      type: Boolean,
    },
  },
  data() {
    return {
      radio: 1,
    };
  },
  methods: {
      links(){  window.open('http://221.226.72.130:6060/index.html#/login');},
      links1(){  window.open('http://njsg.f3322.org:28081/jeesns/');},
    handleClose() {
      this.$emit("closepop");
    },
  },
};
</script>

<style lang="scss" scoped>
.lip {
  .div1 {
    width: 60%;
margin:10px auto;
    display: grid;
    place-items: center;
    grid-template-columns: 2fr 1fr;
    .divp{
            text-align: left;
    }
    img{
        max-width:80px ;
        height: auto;
    }
  }
}
.bodys {
  width: 100%;
  height: 450px;
  .body_div {
    width: 100%;
    height: 40%;
  }
  .body_from {
    width: 100%;
    height: 60%;

    .froms {
      display: grid;
      grid-template-columns: 1fr 4fr;
      margin-top: 20px;

      .from1 {
        display: grid;
        justify-items: center;
        align-items: end;
      }
      .from2 {
        padding-right: 20px;
      }
    }
    .froms1 {
      display: grid;
      grid-template-columns: 1fr 3fr 1fr;
      margin-top: 20px;

      .from1 {
        display: grid;
        justify-items: center;
        align-items: end;
      }
      .from2 {
        padding-right: 20px;
      }
    }
  }
}
.btn {
  display: grid;
  place-items: center;
}
::v-deep.el-dialog__header {
  display: none;
}
::v-deep.el-input__inner {
  border: none;
  border-bottom: 1px solid #dcdfe6;
  border-radius: 0px;
}
::v-deep.el-dialog__body {
  padding: 0;
}
</style>
